import { Link } from "react-router-dom";
import { AI_NAVIGATION_REGISTRY, AiRenderPayload } from "./aiNavigation";

type AiStructuredMessageProps = {
  payload: AiRenderPayload;
};

const AiStructuredMessage = ({
  payload,
}: AiStructuredMessageProps): JSX.Element => (
  <div className="ai-structured-message">
    <h3 className="ai-message-heading">ビズAIの回答</h3>
    <p className="ai-message-summary">{payload.summary}</p>

    {payload.steps.length > 0 && (
      <section>
        <h4>操作手順</h4>
        <ol className="ai-message-steps">
          {payload.steps.map((step, index) => {
            const navigation =
              step.navigation_target === "none"
                ? null
                : AI_NAVIGATION_REGISTRY[step.navigation_target];

            return (
              <li key={`${step.navigation_target}-${index}`}>
                {navigation && (
                  <Link
                    to={navigation.path}
                    className="ai-message-navigation-link"
                    aria-label={navigation.label}
                  >
                    {navigation.label}
                  </Link>
                )}
                {navigation && " "}
                <span className="ai-message-step-text">{step.text}</span>
              </li>
            );
          })}
        </ol>
      </section>
    )}

    {payload.notes.length > 0 && (
      <section>
        <h4>補足</h4>
        <ul className="ai-message-notes">
          {payload.notes.map((note, index) => (
            <li key={index}>
              <span className="ai-message-note-text">{note}</span>
            </li>
          ))}
        </ul>
      </section>
    )}
  </div>
);

export default AiStructuredMessage;
